<template>
  <div id="app" class="bg-black">
    <Bootstrap v-if="!instructions" />

    <button
      class="button-go text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl uppercase px-4 py-2 font-bold text-white bg-orange-light rounded-sm shadow-sm"
      v-if="instructions"
      v-on:click="
        instructions = false;
        startGame();
      "
    >
      Inizia a giocare
    </button>

    <Slides v-if="instructions" />
  </div>
</template>

<script>
import Bootstrap from "./components/Bootstrap";
import Slides from "./components/Slides";
import store from "./store";
import game from "./game";
import styles from "./assets/css/custom.css";
import { getXAxisValue } from "./utils";

const settings = {
  animationDelay: 200,
  deckCount: 1,
  allowSurrender: false,
  allowLateSurrender: false,
  checkDeviations: false,
  gameMode: "default",
  cardCounterType: null,
};

export default {
  name: "App",
  store,
  data: function () {
    return {
      instructions: true,
    };
  },
  methods: {
    startGame: function () {
      game.on("change", (name, value) => {
        if (game.state.step == "game-result") {
          this.$eventHub.$emit("game-over");
        }

        store.commit("changeGameState", game);
        const dealerValue =
          this.dealerLastCard === "J" ||
          this.dealerLastCard === "K" ||
          this.dealerLastCard === "Q"
            ? 10
            : this.dealerLastCard;

        this.$eventHub.$emit("strategyHint", {
          x: getXAxisValue(this.playerCards, this.playerTotal),
          y: dealerValue,
        });

        // committing change
        store.commit("changeTableState", {
          x: getXAxisValue(this.playerCards, this.playerTotal),
          y: dealerValue,
        });

        store.commit("changeHint", {
          x: getXAxisValue(this.playerCards, this.playerTotal),
          y: dealerValue,
        });
      });

      game.on("shuffle", () => {
        console.log("End of shoe, cards shuffled!");
      });
    },
  },
  mounted() {
    if (!this.instructions) {
      this.startGame();
    }

    async function startGame(game) {
      while (true) {
        try {
          // `betAmount` is a cent value.
          await game.step({ betAmount: 100 * 100 });
        } catch (error) {
          if (error.message === "Game reset") {
            continue;
          }

          throw error;
        }
      }
    }

    startGame(game);
  },
  computed: {
    dealerLastCard() {
      return this.$store.getters.dealerLastCard;
    },
    playerTotal() {
      return this.$store.getters.playerTotalCardsValue;
    },
    playerCards() {
      return this.$store.getters.playerCards;
    },
  },
  components: {
    Bootstrap,
    Slides,
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue